export function profileVerificationPresentation(profile) {
    if (profile?.status !== 'confirmed') return { label: 'Ej bekräftade', variant: 'secondary' };
    if (profile.verifiedByUserId === 'system:profile') {
        return { label: 'Hämtade automatiskt', variant: 'info' };
    }
    return { label: 'Bekräftade av administratör', variant: 'success' };
}
